/** Resolve avatar preview from API fields (storage key + generated URL). */
export function resolveStoredUploadPreview(
  image?: string | null,
  imageUrl?: string | null
): string {
  if (typeof imageUrl === "string" && imageUrl.trim() !== "") {
    return imageUrl.trim();
  }
  if (typeof image === "string" && /^https?:\/\//i.test(image)) {
    return image.trim();
  }
  return "";
}

export function isUploadStorageKey(value?: string | null): boolean {
  return typeof value === "string" && value.startsWith("uploads/");
}
